import React from 'react'
import style from "./model.module.scss"
import Icon from 'components/Icon/Icon'

const ModelLoading = React.memo(() => {
  return (
    <div className={style['model-loading']}>
      <Icon 
        icon="iconloading"
        spin={true}
      />
    </div>
  )
})

export default ModelLoading
